import React from "react";

export default function Dashboard() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4 py-10">
      <div className="text-center">
        <p className="text-2xl font-bold text-gray-900">Página em construção</p>
        <p className="mt-2 text-sm text-gray-600">
          Ainda estamos preparando novidades para esta tela.
        </p>
      </div>
    </div>
  );
}
